import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=1678f8ea&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1678f8ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1678f8ea')) {
      api.createRecord('1678f8ea', component.options)
    } else {
      api.reload('1678f8ea', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=1678f8ea&scoped=true&", function () {
      api.rerender('1678f8ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zyODrfCoMGXu/JS/comp/Voucher-Unit.vue"
export default component.exports